module Meevo.Model {
	 
	export enum ApplicationEnum {
		ClientApp = 6,
		ClientIntakeForm = 5,
		DocsAndForms = 4,
		Egift = 3,
		Meevo = 1,
		MyMeevoApp = 8,
		OnlineBooking = 2,
		OnlineMembership = 9,
		SelfPay = 7,
	}
	 
	export enum NounClassEnum {
		ActivityLog = 4,
		AdpIntegration = 142,
		AdpWfnIntegration = 1036,
		AdpWiselyIntegration = 1040,
		AdvancedMarketing = 125,
		Alerts = 5,
		AlertsManager = 6,
		Appointment = 3,
		AppointmentBook = 2,
		AppointmentCategory = 1,
		Aveda = 139,
		BasicMarketing = 110,
		BlockSchedule = 8,
		BlockType = 7,
		BookingAgent = 15,
		BulkLiabilityTransfer = 2011,
		BulkLiabilityUpdate = 2010,
		BusinessInfo = 9,
		BusinessType = 10,
		CancellationReaon = 16,
		Client = 17,
		ClientApp = 1030,
		ClientFind = 119,
		ClientGiftCard = 120,
		ClientIntakeForm = 132,
		ClientManualMerge = 1024,
		ClientPointManager = 20,
		ClientType = 19,
		ClientVisitNote = 18,
		CompensationSettings = 11,
		ConfirmationManager = 21,
		Convobar = 133,
		CulturalSettings = 134,
		CurrencyAndTax = 23,
		CustomBranding = 22,
		DataExport = 1038,
		Department = 108,
		Discount = 24,
		Distributor = 25,
		DocsAndForms = 124,
		Drawer = 26,
		DrawerHistory = 27,
		DrawerManager = 28,
		EftControlPanel = 29,
		eGift = 109,
		Email = 30,
		Employee = 31,
		EmployeeCategory = 32,
		EmployeeColumnOrder = 33,
		EmployeePromotion = 35,
		EmployeeServiceTimesPricing = 140,
		EmployeeSupplyUsage = 36,
		EmployeeTemplate = 34,
		Equipment = 37,
		EventsSchedule = 12,
		FameAdvantage = 1003,
		FeatureTab = 137,
		FieldLabels = 118,
		FiveStarRatings = 141,
		FloorLocation = 38,
		FundingSource = 2004,
		GiftCardBalance = 39,
		GiftCardType = 40,
		GoalsDashboard = 116,
		Holidays = 13,
		Home = 41,
		ImageGalleryCategory = 42,
		Integration = 47,
		IntelliMerge = 46,
		Inventory = 43,
		InventoryReturn = 44,
		InventoryTransfer = 1016,
		IpRestriction = 45,
		KeyboardShortcut = 131,
		LocationGroup = 48,
		LocationMaintenance = 107,
		Login = 49,
		Manufacturer = 58,
		MarketPricing = 56,
		MarkItemsOnSale = 57,
		MeevoBI = 1014,
		MeevoMenu = 136,
		MeevoMessenger = 1017,
		MeevoStore = 115,
		MeevoTheming = 1043,
		MemberBenefitTemplate = 53,
		Membership = 50,
		MembershipBill = 51,
		MembershipCancellationReason = 52,
		MembershipManager = 54,
		MembershipType = 55,
		MerchantAccount = 59,
		MiscellaneousSupply = 60,
		MyMeevoApp = 2003,
		NotificationBilling = 114,
		NotificationSetting = 14,
		NotificationTemplate = 62,
		NotSpecified = 61,
		OnlineBookingSetting = 63,
		Package = 64,
		PackageLookup = 65,
		PageSent = 135,
		Paging = 121,
		Password = 66,
		PayInOutReason = 67,
		PaymentPlanManager = 1027,
		PaymentRequest = 1041,
		PaymentType = 68,
		Payroll = 69,
		PointPromotionCampaign = 113,
		PosHardware = 70,
		PriceManagement = 71,
		Product = 72,
		ProductBulkUpdate = 157,
		ProductBundle = 73,
		ProductCategory = 74,
		ProfileSetting = 75,
		PurchaseOrder = 76,
		Push = 2005,
		QuickBooks = 111,
		QuickBooksDesktop = 1011,
		RatingsControlPanel = 126,
		ReferralType = 77,
		Register = 78,
		Report = 79,
		ReportingHierarchy = 80,
		ReportScheduler = 1531,
		Resource = 81,
		ResourceCategory = 82,
		ResourceColumnOrder = 83,
		RoyaltyExport = 1010,
		SaleLineRating = 130,
		SalesRanking = 123,
		SalonClouds = 112,
		Schedule = 84,
		Security = 85,
		SecurityElevation = 86,
		SecurityRoleManager = 87,
		SelfCheckInKiosk = 138,
		Service = 89,
		ServiceAddOnMapping = 90,
		ServiceCategory = 88,
		ServiceCharges = 1001,
		ServicesWizard = 128,
		ShippingFee = 1044,
		SmartCenterDesigner = 91,
		SMS = 92,
		StandingDefinition = 93,
		StockLevel = 94,
		StudentTeacher = 129,
		SupplyUsageReason = 1039,
		SwapGroup = 95,
		SystemToolbox = 1015,
		TechSphere = 127,
		Textel = 117,
		TextelMarketing = 1006,
		TimeClock = 96,
		Transaction = 97,
		TransactionEditor = 98,
		Transworld = 122,
		UserDefinedField = 100,
		VisitNoteType = 99,
		WaitList = 101,
		WalkInManager = 102,
		WalkInManagerDisplay = 103,
		WalkInManagerKiosk = 104,
		WalkInManagerSetting = 105,
		WorkActivity = 106,
		YEXT = 1018,
		YieldManagementProgram = 1013,
		YieldManagementStrategy = 1012,
		Zapier = 2007,
	}
	 
	export enum NounEnum {
		AccountSync = 391,
		ActivityLog = 11,
		ActivityLogPage = 12,
		AdpIntegrationCommission = 1516,
		AdpIntegrationEmployees = 1515,
		AdpIntegrationMain = 1514,
		AdpIntegrationWorkActivies = 1517,
		AdpWfnIntegrtionCommission = 1632,
		AdpWfnIntegrtionEmployee = 1631,
		AdpWfnIntegrtionMain = 1630,
		AdpWiselyIntegrtionCardHolder = 1641,
		AdpWiselyIntegrtionMain = 1640,
		AdvancedMarketing = 428,
		AdvancedMarketingPage = 427,
		AgentMode = 1560,
		AlertLog = 13,
		AlertLogsPage = 14,
		AlertManager = 15,
		AlertManagerPage = 16,
		Appointment = 410,
		AppointmentBook = 4,
		AppointmentBookPage = 5,
		AppointmentBookSettings = 490,
		AppointmentCategory = 1,
		AppointmentCategoryMain = 3,
		AppointmentCategorySearchPage = 2,
		AppointmentHeader = 6,
		AppointmentProductUsage = 2022,
		AppointmentService = 7,
		AppointmentServiceAddOn = 8,
		AppointmentServiceSchedule = 9,
		Aveda = 1513,
		BasicMarketing = 393,
		BasicMarketingPage = 394,
		Block = 20,
		BlockSchedule = 10,
		BlockScheduleBlockContainer = 2011,
		BlockScheduleMain = 22,
		BlockScheduleSearchPage = 21,
		BlockType = 17,
		BlockTypeMain = 19,
		BlockTypeSearchPage = 18,
		BookingAgent = 43,
		BookingAgentPage = 44,
		BulkEmployeesBookOnlineConfigModal = 1557,
		BulkEmployeesBookOnlineIntelliBookingConfigModal = 1556,
		BulkEmployeesIntelliBookingConfigModal = 1558,
		BulkLiabilityTransfer = 2037,
		BulkLiabilityTransferMain = 2039,
		BulkLiabilityTransferPage = 2038,
		BulkLiabilityUpdate = 2034,
		BulkLiabilityUpdateMain = 2036,
		BulkLiabilityUpdatePage = 2035,
		BulkServiceConfigModal = 1555,
		BusinessInfo = 23,
		BusinessInfoCurrencyAndTaxMain = 35,
		BusinessInfoEventSearchPage = 25,
		BusinessInfoHours = 380,
		BusinessInfoImageGalleries = 375,
		BusinessInfoImageGallery = 28,
		BusinessInfoMain = 26,
		BusinessInfoPreferences = 27,
		BusinessInfoServiceBookingPriority = 400,
		BusinessInfoServiceCategoryDisplayOrder = 1623,
		BusinessInfoSettings = 365,
		BusinessType = 29,
		BusinessTypeMain = 31,
		BusinessTypeSearchPage = 30,
		CancellationReaonSearchPage = 46,
		CancellationReason = 45,
		CancellationReasonMain = 47,
		ChartsDefinition = 2040,
		ChartsDefinitionBuilderTab = 2042,
		ChartsDefinitionMainTab = 2041,
		ChartsDefinitionSearchPage = 2043,
		Client = 48,
		ClientAccountHistory = 409,
		ClientApp = 1700,
		ClientAppBranding = 1709,
		ClientAppBrandingTab = 1703,
		ClientAppConversation = 1627,
		ClientAppCustomSettings = 1715,
		ClientAppCustomSettingsTab = 1714,
		ClientAppointmentHistory = 408,
		ClientAppPackageMenu = 1711,
		ClientAppPackageMenuTab = 1706,
		ClientAppPage = 1701,
		ClientAppPromotion = 1702,
		ClientAppPromotionTab = 1705,
		ClientAppServiceMenu = 1712,
		ClientAppServiceMenuTab = 1707,
		ClientAppSettings = 1710,
		ClientAppSettingsTab = 1704,
		ClientAppViewBio = 1713,
		ClientAppViewBioTab = 1708,
		ClientBookingPreference = 1507,
		ClientBookingPreferences = 407,
		ClientBookingPreferencesOverrides = 1508,
		ClientCreditCard = 59,
		ClientDiscountHistory = 345,
		ClientDocsAndForms = 524,
		ClientCharts = 550,
		ClientFamilies = 366,
		ClientFamily = 55,
		ClientFindAlertsTab = 418,
		ClientFindAppointmentHistoryTab = 416,
		ClientFindAppointmentToday = 1523,
		ClientFindIncludeCheckOut = 1522,
		ClientFindSearch = 1521,
		ClientFindSendTextMsgTab = 1637,
		ClientFindSendToClientProfile = 415,
		ClientFindSendToTextel = 1638,
		ClientFindTransactionHistoryTab = 417,
		ClientGiftCardHistory = 57,
		ClientHistory = 54,
		ClientImageGalleries = 367,
		ClientImageGallery = 61,
		ClientImageUpdate = 344,
		ClientIntakeForm = 484,
		ClientIntakeFormBuilderTab = 488,
		ClientIntakeFormMain = 486,
		ClientIntakeFormPage = 485,
		ClientIntakeFormSecurity = 487,
		ClientMain = 50,
		ClientManualMerge = 1600,
		ClientMembership = 60,
		ClientNote = 52,
		ClientNotes = 51,
		ClientNotification = 1661,
		ClientNotificationsTab = 1660,
		ClientPackage = 540,
		ClientPackageHistory = 56,
		ClientPointManager = 66,
		ClientPointManagerHistory = 69,
		ClientPointManagerMain = 68,
		ClientPointManagerSearchPage = 67,
		ClientPointSettings = 494,
		ClientSearchPage = 49,
		ClientsSettings = 491,
		ClientTransactionHistory = 58,
		ClientType = 63,
		ClientTypeMain = 65,
		ClientTypeSearchPage = 64,
		ClientUDF = 525,
		ClientVisitNote = 62,
		ClientVisitNotes = 53,
		ClockInOutRulesSettings = 1620,
		CompensationSettings = 499,
		ConfirmationManager = 70,
		ConfirmationManagerPage = 71,
		Convobar = 489,
		CreditCard = 1625,
		CulturalSettings = 513,
		CulturalSettingsMain = 514,
		CurrencyAndTax = 75,
		CurrencyAndTaxMain = 76,
		CustomBranding = 72,
		CustomBrandingCoverDesign = 73,
		CustomBrandingPageDesign = 74,
		CustomBrandingSettings = 502,
		DataExport = 1636,
		Department = 385,
		DepartmentMain = 387,
		DepartmentSearchPage = 386,
		Discount = 77,
		DiscountMain = 79,
		DiscountSearchPage = 78,
		Distributor = 80,
		DistributorMain = 82,
		DistributorNote = 599,
		DistributorSearchPage = 81,
		DocsAndForms = 423,
		DocsAndFormsFormBuilderTab = 426,
		DocsAndFormsMain = 425,
		DocsAndFormsSearchPage = 424,
		DocsAndFormsState = 1662,
		Drawer = 83,
		DrawerHistory = 88,
		DrawerHistoryPage = 89,
		DrawerMain = 85,
		DrawerManager = 90,
		DrawerManagerPage = 91,
		DrawerPosStations = 87,
		DrawerReceipts = 86,
		DrawerSearchPage = 84,
		EftControlPanel = 92,
		EftControlPanelPage = 93,
		Egift = 392,
		EgiftMailPickupTemplates = 529,
		EgiftMain = 526,
		EgiftNotifications = 527,
		EgiftPackages = 530,
		EgiftPromoOptions = 532,
		EgiftPromoOptionsState = 1622,
		EgiftServices = 531,
		EgiftSettingAnnouncements = 2027,
		EgiftSettings = 509,
		EgiftTemplates = 528,
		EgiftTransactions = 533,
		Email = 94,
		Employee = 95,
		EmployeeActual = 377,
		EmployeeActualsPage = 378,
		EmployeeBookingAvailability = 2019,
		EmployeeBookingRestriction = 361,
		EmployeeBookingRestrictions = 104,
		EmployeeCategory = 109,
		EmployeeCategoryMain = 111,
		EmployeeCategorySearchPage = 110,
		EmployeeColumnOrder = 112,
		EmployeeCommissionOverrides = 105,
		EmployeeCompensation = 102,
		EmployeeCompensations = 359,
		EmployeeDeduction = 360,
		EmployeeDeductions = 103,
		EmployeeImageGalleries = 363,
		EmployeeImageGallery = 106,
		EmployeeLicenseInsurance = 101,
		EmployeeLicenseInsurances = 358,
		EmployeeMain = 97,
		EmployeeNote = 108,
		EmployeeNotes = 107,
		EmployeeOnlineBooking = 1653,
		EmployeePromotion = 120,
		EmployeePromotionCommissionOverride = 373,
		EmployeePromotionCommissions = 126,
		EmployeePromotionCompensation = 125,
		EmployeePromotionCompensations = 374,
		EmployeePromotionDeduction = 520,
		EmployeePromotionDeductions = 519,
		EmployeePromotionMain = 122,
		EmployeePromotionSearchPage = 121,
		EmployeePromotionSecurity = 123,
		EmployeePromotionServiceOverride = 372,
		EmployeePromotionServices = 124,
		EmployeeSearchPage = 96,
		EmployeeSecurity = 98,
		EmployeeServiceCommissionOverride = 362,
		EmployeeServices = 100,
		EmployeeServicesOverride = 357,
		EmployeeServiceTimesPricing = 1546,
		EmployeeServiceTimesPricingPage = 1547,
		EmployeeShared = 99,
		EmployeeSupplyUsage = 127,
		EmployeeSupplyUsagePage = 128,
		EmployeeTemplate = 113,
		EmployeeTemplateCommissionOverrides = 119,
		EmployeeTemplateCompensation = 118,
		EmployeeTemplateDeduction = 518,
		EmployeeTemplateDeductions = 517,
		EmployeeTemplateMain = 115,
		EmployeeTemplateSearchPage = 114,
		EmployeeTemplateSecurity = 116,
		EmployeeTemplateServices = 117,
		EmployeeUDF = 537,
		EmployeeUserAlertNotification = 429,
		EmployeeUserSecurity = 356,
		Equipment = 129,
		EquipmentMain = 131,
		EquipmentSearchPage = 130,
		EventsMain = 38,
		EventsSchedule = 36,
		EventsSchedulePage = 37,
		FameAdvantageSettings = 1541,
		FameAdvantageSettingsPage = 1542,
		FameAdvantageSettingsTab = 1543,
		FameAdvantageStudentImportTab = 1544,
		FameAdvantageTimeclockExportTab = 1545,
		FeatureTab = 523,
		FieldLabels = 412,
		FieldLabelsMain = 414,
		FieldLabelsPage = 413,
		FieldLabelsSettings = 510,
		FiveStarRatingsSetting = 1529,
		FiveStarRatingsSettingMainSettings = 1530,
		FloorLocation = 132,
		FloorLocationMain = 134,
		FloorLocationSearchPage = 133,
		GeneralKeyboardShortcut = 482,
		GeneralSettings = 1601,
		GiftCard = 1628,
		GiftCardBalance = 135,
		GiftCardBalancePage = 136,
		GiftCardBulk = 1652,
		GiftCardNote = 1559,
		GiftCardType = 137,
		GiftCardTypeMain = 139,
		GiftCardTypeSearchPage = 138,
		GoalsDashboard = 404,
		GoalsDashboardPage = 405,
		HelpDeskTicketSettings = 497,
		HelpSectionSettings = 1570,
		Holidays = 39,
		HolidaysMain = 40,
		Home = 140,
		ImageGalleryCategory = 141,
		ImageGalleryCategoryMain = 143,
		ImageGalleryCategorySearchPage = 142,
		Integration = 154,
		IntegrationsErrorLog = 157,
		IntegrationSettings = 504,
		IntegrationsMain = 156,
		IntegrationsSearchPage = 155,
		IntelliMerge = 152,
		IntelliMergePage = 153,
		InventoryCount = 144,
		InventoryCountPage = 146,
		InventoryCountSearchPage = 145,
		InventoryReturn = 147,
		InventoryReturnMain = 149,
		InventoryReturnSearchPage = 148,
		InventoryTransfer = 1591,
		InventoryTransferNote = 1593,
		InventoryTransferNotePage = 1592,
		InventoryTransferPage = 1595,
		InventoryTransferSearchPage = 1594,
		IpRestriction = 150,
		IpRestrictionMain = 151,
		LicenseInsuranceSettings = 492,
		LocationGroup = 158,
		LocationGroupMain = 160,
		LocationGroupSearchPage = 159,
		LocationMaintenance = 347,
		LocationMaintenanceMain = 349,
		LocationMaintenanceSearchPage = 348,
		Login = 161,
		ManagePastHolidays = 1624,
		Manufacturer = 196,
		ManufacturerMain = 198,
		ManufacturerNote = 548,
		ManufacturerSearchPage = 197,
		MarketPricing = 179,
		MarketPricingDiscounts = 182,
		MarketPricingGiftCardtypes = 184,
		MarketPricingHistory = 190,
		MarketPricingLocations = 189,
		MarketPricingMain = 181,
		MarketPricingMemberBenefitTemplates = 186,
		MarketPricingMemberships = 185,
		MarketPricingPackages = 183,
		MarketPricingProducts = 187,
		MarketPricingSearchPage = 180,
		MarketPricingServices = 188,
		MarkItemsOnSale = 191,
		MarkItemsOnSaleMain = 193,
		MarkItemsOnSaleProducts = 195,
		MarkItemsOnSaleSearchPage = 192,
		MarkItemsOnSaleServices = 194,
		MeevoBI = 1581,
		MeevoBIMain = 1583,
		MeevoBIPage = 1582,
		MeevoMenu = 522,
		MeevoMessengerArrivals = 1597,
		MeevoMessengerArrivalsConversation = 1599,
		MeevoMessengerArrivalsSettings = 1598,
		MeevoStore = 402,
		MeevoStorePage = 403,
		MeevoTheming = 1645,
		MeevoThemingDataMaint = 1648,
		MeevoThemingSmartCenter = 1647,
		MeevoThemingTaskbar = 1646,
		MemberBenefitTemplate = 171,
		MemberBenefitTemplateMain = 173,
		MemberBenefitTemplateSearchPage = 172,
		Membership = 162,
		MembershipBill = 167,
		MembershipCancellationReason = 168,
		MembershipCancellationReasonMain = 170,
		MembershipCancellationReasonSearchPage = 169,
		MembershipCompensation = 536,
		MembershipCompensationTab = 166,
		MembershipDocsAndForms = 165,
		MembershipMain = 164,
		MembershipManager = 174,
		MembershipManagerBenefits = 354,
		MembershipManagerCC = 351,
		MembershipManagerHistory = 355,
		MembershipManagerMain = 350,
		MembershipManagerPage = 175,
		MembershipManagerPayments = 352,
		MembershipManagerTransfers = 353,
		MembershipPaymentAccount = 2020,
		MembershipSearchPage = 163,
		MembershipSettings = 498,
		MembershipType = 176,
		MembershipTypeMain = 178,
		MembershipTypeSearchPage = 177,
		MenuKeyboardShortcut = 483,
		MerchantAccount = 199,
		MerchantAccountAdminSettings = 2010,
		MerchantAccountAdminSettingsTab = 2009,
		MerchantAccountCareCreditManagePromotions = 1621,
		MerchantAccountDevices = 202,
		MerchantAccountMain = 201,
		MerchantAccountSearchPage = 200,
		MerchantAccountSurcharges = 2013,
		MerchantAccountSurchargesTab = 2012,
		MerchantTerminal = 368,
		MiscellaneousSupply = 203,
		MiscellaneousSupplyMain = 205,
		MiscellaneousSupplySearchPage = 204,
		MyMeevoApp = 2015,
		NotificationBilling = 399,
		NotificationSetting = 41,
		NotificationSettingMain = 42,
		NotificationSettings = 501,
		NotificationTemplate = 207,
		NotificationTemplateMain = 209,
		NotificationTemplateSearchPage = 208,
		NotSpecified = 206,
		OnlineBookingClient = 376,
		OnlineBookingSetting = 210,
		OnlineBookingSettingAnnouncements = 1654,
		OnlineBookingSettingEmployees = 431,
		OnlineBookingSettingMain = 211,
		OnlineBookingSettings = 505,
		OnlineBookingSettingServices = 432,
		OnlineBookingSiteSettings = 506,
		OnlinePresenceManagement = 1021,
		OnlinePresenceSettings = 1025,
		Package = 212,
		PackageCompensation = 369,
		PackageCompensationTab = 370,
		PackageLookup = 215,
		PackageLookupPage = 216,
		PackageMain = 214,
		PackageSearchPage = 213,
		PageSent = 521,
		Paging = 420,
		Password = 217,
		PayIn = 219,
		PayInOutReason = 218,
		PayInOutReasonMain = 222,
		PayInOutReasonSearchPage = 221,
		PaymentConsole = 1643,
		PaymentPlan = 1618,
		PaymentPlanManagerCC = 1615,
		PaymentPlanManagerHistory = 1617,
		PaymentPlanManagerMain = 1613,
		PaymentPlanManagerNotes = 1616,
		PaymentPlanManagerPayments = 1614,
		PaymentPlanManagerSearchPage = 1612,
		PaymentPlanPayment = 1619,
		PaymentPlanPaymentAccount = 2021,
		PaymentRequest = 1649,
		PaymentRequestVoid = 1650,
		PaymentType = 223,
		PaymentTypeMain = 225,
		PaymentTypeSearchPage = 224,
		PayOut = 220,
		Payroll = 226,
		PayrollPage = 515,
		PayrollSettings = 32,
		PayrollSettingsClockInOutRules = 1540,
		PayrollSettingsCommissionDetail = 516,
		PayrollSettingsMain = 33,
		PayrollSettingsSplitCommissions = 34,
		PayrollSettingsSplitCommissionSetting = 346,
		PeriodSettings = 500,
		PhoneNumber = 2007,
		PointPromotionCampaign = 395,
		PointPromotionCampaignMain = 397,
		PointPromotionCampaignPromotions = 398,
		PointPromotionCampaignSearchPage = 396,
		PosHardware = 227,
		PosHardwarePosStation = 228,
		PosHardwareReceiptPrinter = 229,
		PriceManagement = 230,
		PriceManagementDiscounts = 232,
		PriceManagementGiftCardTypes = 234,
		PriceManagementHistory = 240,
		PriceManagementLocations = 239,
		PriceManagementMain = 231,
		PriceManagementMemberBenefitTemplates = 236,
		PriceManagementMemberships = 235,
		PriceManagementPackages = 233,
		PriceManagementProducts = 406,
		PriceManagementService = 237,
		PriceManagementServices = 238,
		Product = 241,
		ProductBulkUpdate = 577,
		ProductBulkUpdatePage = 579,
		ProductBulkUpdateSearchPage = 578,
		ProductBundle = 244,
		ProductBundleAssembleDisassemble = 247,
		ProductBundleMain = 246,
		ProductBundleSearchPage = 245,
		ProductCategory = 248,
		ProductCategoryMain = 250,
		ProductCategorySearchPage = 249,
		ProductCompensation = 534,
		ProductCompensationTab = 388,
		ProductMain = 243,
		ProductSearchPage = 242,
		ProductTracking = 1664,
		ProductTrackingTab = 1663,
		ProductUDF = 538,
		ProductVariantTypeAhead = 547,
		ProfileSetting = 251,
		ProfileSettingMain = 252,
		ProfileSettingServices = 253,
		PurchaseOrder = 254,
		PurchaseOrderNote = 256,
		PurchaseOrderNotes = 255,
		PurchaseOrdersPage = 258,
		PurchaseOrdersSearchPage = 257,
		Push = 2023,
		QuickBooksDesktop = 1602,
		QuickBooksDesktopMain = 1604,
		QuickBooksDesktopPage = 1603,
		QuickBooksOnline = 1605,
		QuickBooksOnlineMain = 1607,
		QuickBooksOnlinePage = 1606,
		RatingsControlPanel = 430,
		ReceivedPurchaseOrder = 433,
		ReferralType = 259,
		ReferralTypeMain = 261,
		ReferralTypeSearchPage = 260,
		Register = 262,
		RegisterClient = 265,
		RegisterPage = 263,
		RegisterSettings = 495,
		Report = 266,
		ReportingHierarchy = 268,
		ReportingHierarchyDesignHierarchy = 271,
		ReportingHierarchyMain = 270,
		ReportingHierarchySearchPage = 269,
		ReportingHierarchySetLocations = 272,
		ReportPage = 267,
		ReportScheduler = 1532,
		ReportSchedulerMain = 1534,
		ReportSchedulerSearchPage = 1533,
		Resource = 273,
		ResourceCategory = 276,
		ResourceCategoryMain = 278,
		ResourceCategorySearchPage = 277,
		ResourceColumnOrder = 279,
		ResourceMain = 275,
		ResourceSearchPage = 274,
		RoyaltyExport = 1568,
		RoyaltyExportExclusions = 1569,
		RoyaltyExportMain = 1567,
		Sale = 401,
		SaleHold = 264,
		SaleLineRating = 480,
		SalesRanking = 422,
		Schedule = 280,
		SchedulesPage = 281,
		SecurityElevation = 382,
		SecurityElevationModal = 285,
		SecurityRole = 282,
		SecurityRoleMain = 284,
		SecurityRoleManager = 286,
		SecurityRoleSearchPage = 283,
		SecurityRolesManagerPage = 287,
		SecuritySettings = 507,
		SelfCheckInKiosk = 543,
		SelfCheckInKioskAppointmentService = 546,
		SelfCheckInKioskAppointmentServiceAddOn = 545,
		SelfCheckInKioskSearchClientScreen = 544,
		SelfCheckinSetting = 541,
		SelfCheckinSettingMainSettings = 542,
		SelfPay = 1572,
		Service = 292,
		ServiceAddOnMapping = 301,
		ServiceAddOnMappingMain = 303,
		ServiceAddOnMappingSearchPage = 302,
		ServiceCategory = 288,
		ServiceCategoryImageGallery = 371,
		ServiceCategoryImageGalleryTab = 291,
		ServiceCategoryMain = 290,
		ServiceCategorySearchPage = 289,
		ServiceCharges = 1550,
		ServiceChargesMain = 1552,
		ServiceChargesSearchPage = 1551,
		ServiceCompensation = 535,
		ServiceCompensationTab = 299,
		ServiceEmployees = 1553,
		ServiceEmployeesOverride = 1554,
		ServiceMain = 294,
		ServiceNote = 300,
		ServiceNotes = 296,
		ServiceNotifications = 295,
		ServiceProductUsage = 2025,
		ServiceProductUsageTab = 2014,
		ServiceResources = 297,
		ServiceSearchPage = 293,
		ServiceSplitMerge = 298,
		ServiceSplitServices = 384,
		ServicesWizard = 435,
		ServiceUDF = 539,
		SettingsManager = 24,
		ShippingFee = 1655,
		ShippingFeeMain = 1656,
		ShippingFeePage = 1657,
		SmartCenterDesigner = 304,
		SmartCenterDesignerMain = 306,
		SmartCenterDesignerSearchPage = 305,
		SmartCenterSettings = 496,
		SMS = 307,
		SplitCommission = 381,
		StandingDefinition = 308,
		StandingDefinitionMain = 310,
		StandingDefinitionManageAppointments = 383,
		StandingDefinitionSearchPage = 309,
		StockLevel = 311,
		StockLevelPage = 312,
		Student = 436,
		StudentBookingRestriction = 451,
		StudentBookingRestrictions = 450,
		StudentCommissionOverrides = 452,
		StudentCompensation = 446,
		StudentCompensations = 447,
		StudentDeduction = 449,
		StudentDeductions = 448,
		StudentImageGalleries = 455,
		StudentImageGallery = 454,
		StudentLicenseInsurance = 444,
		StudentLicenseInsurances = 445,
		StudentMain = 440,
		StudentNote = 457,
		StudentNotes = 456,
		StudentOnlineBooking = 1658,
		StudentSearchPage = 439,
		StudentSecurity = 441,
		StudentServiceCommissionOverride = 453,
		StudentServices = 438,
		StudentServicesOverride = 443,
		StudentShared = 437,
		StudentUserSecurity = 442,
		SwapGroup = 313,
		SwapGroupMain = 315,
		SwapGroupSearchPage = 314,
		SyncOnlineBusinessInformation = 1608,
		SystemToolbox = 1587,
		SystemToolboxMain = 1588,
		SystemToolboxTokenMigration = 2004,
		SystemToolboxTokenMigrationActions = 2008,
		TaxSettings = 503,
		Teacher = 458,
		TeacherBookingRestriction = 473,
		TeacherBookingRestrictions = 472,
		TeacherCommissionOverrides = 474,
		TeacherCompensation = 468,
		TeacherCompensations = 469,
		TeacherDeduction = 471,
		TeacherDeductions = 470,
		TeacherImageGalleries = 477,
		TeacherImageGallery = 476,
		TeacherLicenseInsurance = 466,
		TeacherLicenseInsurances = 467,
		TeacherMain = 462,
		TeacherNote = 479,
		TeacherNotes = 478,
		TeacherOnlineBooking = 1659,
		TeacherSearchPage = 461,
		TeacherSecurity = 463,
		TeacherServiceCommissionOverride = 475,
		TeacherServices = 460,
		TeacherServicesOverride = 465,
		TeacherShared = 459,
		TeacherUserSecurity = 464,
		TechSphere = 434,
		TechSphereSettings = 512,
		Textel = 411,
		TextelConversation = 1561,
		TextelMarketing = 1564,
		TextelMarketingMain = 1565,
		TextelSettings = 481,
		TimeClock = 316,
		TimeClockMyTimesheet = 379,
		TimeClockPage = 317,
		Tippy = 2003,
		Transaction = 318,
		TransactionClientGiftCard = 419,
		TransactionClients = 1511,
		TransactionEditor = 322,
		TransactionEditorPage = 323,
		TransactionEmployee = 319,
		TransactionPackagePurchasedFors = 1512,
		TransactionPayment = 321,
		TransactionProducts = 1510,
		TransactionServices = 1509,
		TransactionTips = 320,
		TransferExportPage = 1610,
		Transworld = 421,
		TransworldFieldsSettings = 511,
		Ungrandfathering = 1566,
		UsageReason = 1751,
		UsageReasonMain = 1752,
		UserDefinedField = 327,
		UserDefinedFieldPage = 328,
		UsersSettings = 493,
		VisitNoteType = 324,
		VisitNoteTypeMain = 326,
		VisitNoteTypeSearchPage = 325,
		WaitList = 329,
		WaitListPage = 330,
		WalkInManager = 331,
		WalkInManagerDisplay = 333,
		WalkInManagerDisplayPage = 334,
		WalkInManagerKiosk = 335,
		WalkInManagerKioskPage = 336,
		WalkInManagerModal = 364,
		WalkInManagerPage = 332,
		WalkInManagerSetting = 337,
		WalkInManagerSettingEmployees = 389,
		WalkInManagerSettingMainSettings = 338,
		WalkInManagerSettingNotifications = 339,
		WalkInManagerSettings = 508,
		WalkInManagerSettingServices = 390,
		WalkInManagerSettingWalkInHours = 340,
		WorkActivity = 341,
		WorkActivityMain = 343,
		WorkActivitySearchPage = 342,
		YieldManagementProgram = 1578,
		YieldManagementProgramClient = 1584,
		YieldManagementProgramEmployee = 1586,
		YieldManagementProgramMain = 1580,
		YieldManagementProgramPage = 1579,
		YieldManagementProgramService = 1585,
		YieldManagementStrategy = 1575,
		YieldManagementStrategyMain = 1577,
		YieldManagementStrategySearchPage = 1576,
		Zapier = 2026,
	}
	 
	export enum PurposeEnum {
		Audit = 1,
		Security = 3,
		UsageTracking = 2,
	}
	 
	export enum VerbEnum {
		Abandoned = 502,
		Accepted = 401,
		AcceptedButtonClicked = 512,
		Accessed = 1537,
		ActionFailed = 501,
		Activated  = 12028,
		ActivateImportedTokens = 12082,
		AddedCreditCard = 12038,
		AddMemberClicked = 337,
		AddNewButtonClicked = 100,
		AddNote = 457,
		AddToSaleClicked = 12062,
		AddToWaitListClicked = 313,
		AddToWalkInManagerButtonClicked = 310,
		AdpMappingsCleared = 12045,
		AdvancedSearchButtonClicked = 107,
		ApplyButtonClicked = 300,
		AppointmentAdded = 450,
		AppointmentCancelled = 452,
		AppointmentCheckedIn = 454,
		AppointmentEdited = 451,
		AppointmentNoShow = 455,
		AppointmentNotesViewed = 507,
		AppointmentRunningLate = 453,
		AppointmentTodayButtonClicked = 511,
		Approved = 12086,
		AssociatedServicesRemoved = 402,
		Attempted = 12026,
		AwaitingResponse = 428,
		BackFromEmployeesClicked = 319,
		BackFromServicesClicked = 318,
		BackFromSummaryClicked = 312,
		BreakFamilyClicked = 336,
		BreakInButtonClicked = 334,
		BreakOutButtonClicked = 333,
		BusinessBoosterAdded = 434,
		BusinessBoosterRemoved = 435,
		BypassDeposit = 12030,
		CancelButtonClicked = 103,
		Cancelled = 503,
		CheckBoxButtonClicked = 509,
		CheckedIn = 504,
		CheckoutButtonClicked = 304,
		ClickedToSchedule = 12011,
		ClientFindButtonClicked = 510,
		ClientMembershipEFTPaid = 456,
		ClientNotesViewed = 508,
		ClockInButtonClicked = 332,
		ClockOutButtonClicked = 331,
		CloseButtonClicked = 357,
		Closed = 431,
		ColumnOrderChanged = 405,
		Completed = 12024,
		ConfigureLocations = 7,
		ConfigurePayrollClicked = 349,
		Confirmed = 403,
		ConfirmPayrollSettingsSaveClicked = 350,
		ConfirmStateUpdated = 448,
		ContinueFromClientsClicked = 311,
		ContinueFromEmployeesClicked = 317,
		ContinueFromServicesClicked = 316,
		Copied = 6,
		CopyButtonClicked = 104,
		CopyForwardApplyButtonClicked = 324,
		CopyForwardButtonClicked = 323,
		Created = 1,
		CreateHolidayButtonClicked = 338,
		CustomTextEvaluatedFailed = 347,
		CustomTextEvaluatedSuccessfully = 346,
		DataExported = 12071,
		DeleteButtonClicked = 105,
		Deleted = 4,
		DeletedCreditCard = 12039,
		DeleteForwardApplyButtonClicked = 326,
		DeleteForwardButtonClicked = 325,
		DeleteHolidayButtonClicked = 340,
		DeleteNote = 459,
		DeletePaymentClicked = 355,
		Delivered = 404,
		Denied = 202,
		DocsAndFormsSubmitted = 449,
		EditButtonClicked = 102,
		EditClosingCash = 429,
		EditHolidayButtonClicked = 339,
		EditionPlanChanged = 432,
		EditOpeningCash = 406,
		Elevated = 203,
		EmailPurchaseOrderReport = 465,
		EmailReceiptButtonClicked = 306,
		EmployeeAfterPromotion = 408,
		EmployeePriorPromotion = 407,
		EmployeeTemplateApplied = 12027,
		Ended = 12005,
		ErrorMasqueradingAsSuccessfulWarningThrown = 12052,
		ExclusionsViewed = 12012,
		ExportButtonClicked = 341,
		ExternalMembershipTransferredFrom = 439,
		ExternalMembershipTransferredTo = 438,
		Failed = 400,
		Failure = 302,
		Feature = 358,
		Finalized = 409,
		ForgotPassword = 444,
		FullAccessMfaDisable = 12076,
		Generated = 1535,
		GenerateMappingFile = 12081,
		GenerationFailed = 12002,
		Granted = 201,
		Inactivated = 1538,
		InProgressCompleteClick = 315,
		IntegrationAdded = 436,
		IntegrationRemoved = 437,
		ItemNoShowClicked = 320,
		ItemReinsertClicked = 321,
		KeyboardShortcutPressed = 111,
		Locked = 1100,
		LogViewed = 12066,
		MarketPricingChanged = 424,
		MarketPricingCreated = 423,
		MembershipChanged = 421,
		MembershipDeleted = 422,
		MembershipNotesViewed = 12031,
		MembershipSwitched = 440,
		MfaDisable = 12078,
		MfaEnable = 12077,
		MyScheduleButtonClicked = 329,
		MyTimesheetButtonClicked = 330,
		NoSaleClicked = 356,
		NoShow = 506,
		NoShowsClicked = 314,
		NotDelivered = 1536,
		NotificationBillingSubmitted = 426,
		Opened = 430,
		PageViewEvent = 109,
		PasswordMismatched = 443,
		PasteButtonClick = 322,
		PaymentPlanChanged = 12054,
		PaymentPlanEFTDayChanged = 12056,
		PaymentPlanEFTPaid = 12059,
		PaymentPlanNumberOfPaymentsChanged = 12057,
		PaymentPlanPaymentMethodChanged = 12058,
		PaymentPlanProcessEFT = 12060,
		PaymentPlanRefund = 12055,
		PaymentValidationFailed = 12001,
		PayrollDetailsViewed = 352,
		PayrollPeriodViewed = 351,
		PendingCreated = 12069,
		PendingRejected = 12070,
		Popped = 410,
		PopRequest = 411,
		PriceManagementChanged = 425,
		PrintReceiptButtonClicked = 305,
		PriorityChange = 412,
		ProcessCreditClicked = 354,
		Processed = 12010,
		ProductUsageDisabledWarningViewed = 12092,
		PromotionClicked = 12046,
		PromotionViewed = 12047,
		Purged = 9,
		Ran = 12013,
		Read = 2,
		RecallButtonClicked = 12019,
		ReceiveButtonClicked = 12020,
		Received = 413,
		RefundButtonClicked = 307,
		Rejected = 414,
		RejectedButtonClicked = 513,
		Replaced = 415,
		ReportRun = 416,
		Resent = 995,
		ResetClientPointsAlertNoClicked = 12016,
		ResetClientPointsAlertYesClicked = 12014,
		ResetClientPointsWarningNoClicked = 12017,
		ResetClientPointsWarningYesClicked = 12015,
		ResetPassword = 445,
		Restricted = 1102,
		Resubmitted = 12085,
		ReturnButtonClicked = 12021,
		ReturnFromOnHold = 417,
		ReturnFromOnHoldClicked = 12061,
		RunningLate = 505,
		RunReportButtonClicked = 342,
		SaleHoldButtonClicked = 353,
		SaveButtonClicked = 108,
		ScanButtonClicked = 303,
		ScheduleAdded = 12008,
		ScheduleRemoved = 12009,
		ScheduleViewed = 12007,
		SearchButtonClicked = 101,
		Searched = 12068,
		SecurityViolation = 200,
		Selected = 110,
		SelectionCriteriaChanged = 343,
		SelectMerchantAccount = 12083,
		Sent = 418,
		ServiceNotesViewed = 12043,
		SessionEnded = 309,
		SessionStarted = 308,
		ShortcutPressed = 345,
		SMSPlanChanged = 433,
		SMSReceived = 12003,
		SplitCommissionButtonClicked = 301,
		Started = 12004,
		StartFamilyClicked = 335,
		StopPayrollTrackingClicked = 348,
		Submitted = 12084,
		Succeeded = 500,
		SuccessfulPaymentMasqueradingAsErrorWarningThrown = 12051,
		SupportPlanChanged = 441,
		SwitchToActualsButtonClicked = 327,
		SwitchToSchedulesButtonClicked = 328,
		SyncStatus = 12067,
		SyncStatusClicked = 12063,
		TabLoaded = 344,
		TakeOwnership = 8,
		TransferButtonClicked = 12018,
		TransworldStatusChanged = 442,
		Unconfirmed = 427,
		UndeleteButtonClicked = 106,
		Undeleted = 5,
		Undeliverable = 12089,
		UndoPreviousClose = 419,
		Unlocked = 1101,
		Unmasked = 12065,
		Unrestricted = 1103,
		UpdateCreditCardZipCode = 12041,
		Updated = 3,
		UpdatedCreditCard = 12040,
		UpdatedUdf = 12091,
		UpdateNote = 458,
		UserErrorLoggedIn = 447,
		UserLoggedIn = 446,
		Viewed = 112,
		WarningMessageOkButtonClicked = 12053,
		WarningsSuppressed = 420,
		YesButtonClicked = 12022,
	}

	export enum EffectiveLevelFlag {
        System = 0,
        Tenant = 1,
        BusinessType = 2,
        Location = 4,
        SingleLocation = 8,
    }
}
